import {
  CLAIM_ID_SET,
  CLAIM_STATUS_SET,
  CLAIM_CLEAR_ITEMS,
  CLAIM_REQUEST,
  CLAIM_REQUEST_FAILED,
  CLAIM_REQUEST_SUCCESS,
  CLAIM_GET_CLAIM_DETAILS,
  CLAIM_GET_CLAIM_DETAILS_FAILED,
  CLAIM_GET_CLAIM_DETAILS_SUCCESS,
  CLAIM_GET_ID,
  CLAIM_GET_ID_FAILED,
  CLAIM_GET_ID_SUCCESS,
  CLAIM_TYPE_SET,
  CLAIM_GET_PENDING_CLAIMS,
  CLAIM_GET_PENDING_CLAIMS_FAILED,
  CLAIM_GET_PENDING_CLAIMS_SUCCESS,
  CLAIM_ITEM_ADD,
  CLAIM_ITEM_ADD_SUCCESS,
  CLAIM_ITEM_ADD_FAILED,
  CLAIM_ITEM_REMOVE,
  CLAIM_ITEM_REMOVE_SUCCESS,
  CLAIM_ITEM_REMOVE_FAILED,
  CLAIM_STATE_CANCEL,
  CLAIM_STATE_CANCEL_FAILED,
  CLAIM_STATE_CANCEL_SUCCESS,
  CLAIM_RESUME_SET_DETAILS,
  CLAIM_RESUME_SET_DETAILS_FAILED,
  //CLAIM_RESUME_SET_DETAILS_SUCCESS,
  CLAIM_SAVE,
  CLAIM_SAVE_FAILED,
  CLAIM_SAVE_SUCCESS,
  CLAIM_RECEIPT_ADD,
  CLAIM_RECEIPT_ADD_FAILED,
  CLAIM_RECEIPT_ADD_SUCCESS,
  CLAIM_RECEIPT_REMOVE,
  CLAIM_RECEIPT_REMOVE_SUCCESS,
  CLAIM_SUBMIT,
  CLAIM_SUBMIT_FAILED,
  CLAIM_SUBMIT_SUCCESS,
  REPORT_CLAIM_DETAILS_INFO_SUCCESS,
  CLAIM_AUDIT_UPLOAD_SUBMIT,
  CLAIM_AUDIT_UPLOAD_SUBMIT_FAILED,
  CLAIM_AUDIT_UPLOAD_SUBMIT_SUCCESS,
  CLAIM_CANCEL,
  ERROR_CLEAR,
  //SET_LOADING,

  CLAIM_UPDATE_PATIENTS_SUCCESS,

  TOOLS_ACCESS_USER_ACCOUNT_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT,
} from '../actions/types';

export const INITIAL_STATE = {
  id: '',
  type: 'HSA', //WSA or HSA flag
  status: 'N', //N or R for New / Resume
  origin: 'O',
  employee: '',
  total_amount: 0,
  admin_fee: 0,
  copay_pct: 0,
  copay: 0,
  gst: 0,
  hst: 0,
  rst: 0,
  pst: 0,
  prem: 0,
  total: 0,
  payable: 0,
  funded: 0,
  printed: false,
  claimItem: {
    patient: '',
    patient_name: '',
    service_date: '',
    dateTime: new Date(),
    service: '',
    service_name: '',
    provider: '',
    amount: '',
  },
  claimItems: [],
  claimReceipts: [],
  claimReceiptsSkipped: false,
  claimStartDate: new Date(),
  claimEndDate: new Date(),
  patients: [],
  services: [],
  providers: [],
  incompleteClaims: {
    HSA: {},
    WSA: {}
  },
  lastClaimId: '',
  auditFiles: [],
  error: false,
  errors: {},
  loading: false,
  message: ''
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case CLAIM_ID_SET:
        return {
          ...state,
          id: action.payload
        };
      case CLAIM_STATUS_SET:
        return {
          ...state,
          status: action.payload
        };
      case CLAIM_TYPE_SET:
        return {
          ...state,
          type: action.payload,
          // claimItem: INITIAL_STATE.claimItem,
          // claimItems: INITIAL_STATE.claimItems,
          // claimStartDate: INITIAL_STATE.claimStartDate,
          // claimEndDate: INITIAL_STATE.claimEndDate,
          // id: INITIAL_STATE.id,
          // patients: INITIAL_STATE.patients,
          // error: false,
          // errors: {},
          // loading: false
        };
      case CLAIM_CLEAR_ITEMS:
        return { ...state, claimItems: INITIAL_STATE.claimItems };
      case CLAIM_REQUEST:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_REQUEST_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false };
      case CLAIM_REQUEST_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_GET_PENDING_CLAIMS:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_GET_PENDING_CLAIMS_SUCCESS:
        return { ...state, incompleteClaims: action.data.claims, error: false, errors: {}, loading: false };
      case CLAIM_GET_PENDING_CLAIMS_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_GET_ID:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_GET_ID_SUCCESS:
        return {
          ...state,
          id: action.data.id,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_GET_ID_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_GET_CLAIM_DETAILS:
        return {
          ...state,
          // id: INITIAL_STATE.id,
          type: action.claimType,
          status: action.claimStatus,
          claimItems: INITIAL_STATE.claimItems,
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_GET_CLAIM_DETAILS_SUCCESS:
        return {
          ...state,
          patients: action.data.patients,
          services: action.data.services,
          providers: action.data.providers,
          error: false,
          errors: {},
          loading: false
        };

      case CLAIM_UPDATE_PATIENTS_SUCCESS:
        return {
          ...state,
          patients: action.data.patients,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_GET_CLAIM_DETAILS_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_RECEIPT_ADD:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_RECEIPT_ADD_SUCCESS:
        return {
          ...state,
          claimReceipts: [...state.claimReceipts, action.data],
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_RECEIPT_ADD_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_RECEIPT_REMOVE:
        return {
          ...state,
          claimReceipts: state.claimReceipts.filter((item) => item !== action.receipt),
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_RECEIPT_REMOVE_SUCCESS:
        return {
          ...state,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_ITEM_ADD:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_ITEM_ADD_SUCCESS:
        return {
          ...state,
          claimItem: INITIAL_STATE.claimItem,
          // claimItems: [...state.claimItems, action.data.claimItem],
          claimItems: action.data.claimItems,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_ITEM_ADD_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_ITEM_REMOVE:
        return {
          ...state,
          // claimItems: state.claimItems.filter((item) => item !== action.claimItem),
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_ITEM_REMOVE_SUCCESS:
        return {
          ...state,
          claimItems: action.data.claimItems,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_ITEM_REMOVE_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_SAVE:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_SAVE_SUCCESS:
        return {
          ...state,
          id: INITIAL_STATE.id,
          claimItem: INITIAL_STATE.claimItem,
          claimItems: INITIAL_STATE.claimItems,
          claimReceipts: INITIAL_STATE.claimReceipts,
          auditFiles: INITIAL_STATE.auditFiles,
          claimStartDate: INITIAL_STATE.claimStartDate,
          claimEndDate: INITIAL_STATE.claimEndDate,
          incompleteClaims: action.data.incompleteClaims,
          message: action.data.message,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_SAVE_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_SUBMIT:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_SUBMIT_SUCCESS:
        return {
          ...state,
          id: INITIAL_STATE.id,
          providers: action.data.providers,
          claimItem: INITIAL_STATE.claimItem,
          claimItems: INITIAL_STATE.claimItems,
          claimReceipts: INITIAL_STATE.claimReceipts,
          auditFiles: INITIAL_STATE.auditFiles,
          claimStartDate: INITIAL_STATE.claimStartDate,
          claimEndDate: INITIAL_STATE.claimEndDate,
          incompleteClaims: action.data.incompleteClaims,
          lastClaimId: action.data.id,
          message: action.data.message,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_SUBMIT_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_AUDIT_UPLOAD_SUBMIT:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_AUDIT_UPLOAD_SUBMIT_SUCCESS:
        return {
          ...state,
          claimReceipts: INITIAL_STATE.claimReceipts,
          auditFiles: action.data.auditFiles,
          message: action.data.message,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_AUDIT_UPLOAD_SUBMIT_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_STATE_CANCEL:
        return { ...state, error: false, errors: {}, loading: true };
      case CLAIM_STATE_CANCEL_SUCCESS:
        return {
          ...state,
          incompleteClaims: action.data.incompleteClaims,
          message: action.data.message,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_STATE_CANCEL_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case CLAIM_CANCEL:
        return {
          ...state,
          id: INITIAL_STATE.id,
          type: INITIAL_STATE.type,
          claimItem: INITIAL_STATE.claimItem,
          claimItems: INITIAL_STATE.claimItems,
          claimReceipts: INITIAL_STATE.claimReceipts,
          claimStartDate: INITIAL_STATE.claimStartDate,
          claimEndDate: INITIAL_STATE.claimEndDate,
          message: INITIAL_STATE.message,
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_RESUME_SET_DETAILS:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case CLAIM_RESUME_SET_DETAILS_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case ERROR_CLEAR:
        return { ...state, error: false, errors: {}, message: '', loading: false };
      case REPORT_CLAIM_DETAILS_INFO_SUCCESS:
        return {...state, claimDetails: action.claimDetails, auditFiles: action.auditFiles, error: false, errors: {}, message: action.message, loading: false };
      case TOOLS_ACCESS_USER_ACCOUNT_SUCCESS:
        return {
          ...INITIAL_STATE,
          incompleteClaims: action.data.incompleteClaims,
          employee: action.data.user.EMPLOYEE,
          patients: action.data.patients,
          services: action.data.services,
          providers: action.data.providers
        };
      case LOGIN_SUCCESS:
        return {
          ...INITIAL_STATE,
          incompleteClaims: action.data.incompleteClaims,
          employee: action.data.user.EMPLOYEE,
          patients: action.data.patients,
          services: action.data.services,
          providers: action.data.providers
        };
      case LOGOUT:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
